
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    backgroundClass() {
      return this.$backgroundClassPicker(this.data.backgroundColor);
    }
  }
};
